export const PackageStatusOption = {
  CREATED_OR_PACKAGED: { label: "Created/Packaged", value: "Created/Packaged" },
  IN_ROUTE: { label: "In Route", value: "In Route" },
  DELIVERED: { label: "Delivered", value: "Delivered" },
  DELAYED: { label: "Delayed", value: "Delayed" },
  AVAILABLE_FOR_PICKUP: {
    label: "Available for Pickup",
    value: "Available for Pickup",
  },
};
export const PackageExceptionOption = {
  SHORT: { label: "Short", value: "SH" },
  HELD: { label: "Held", value: "HE" },
  DAMAGED: { label: "Damaged", value: "DM" },
  MISROUTED: { label: "Misrouted", value: "MR" },
  BACKORDER: { label: "Backorder", value: "BO" },
  MISSING: { label: "Missing", value: "MS" },
  MISSING_SCAN_EVENT: { label: "Missing Scan Event", value: "LS" },
  LOST: { label: "Lost", value: "LS" },
  RECYCLED: {
    label: "Recycled",
    value: "RE",
  },
};
